import { CuiModal, CuiButton } from 'front-lib'
import { useAtom } from 'jotai'
import { downloadAppModalAtom } from 'src/atoms/downloadAppModal.atom'
import { AppQrCodes } from 'src/componentsV2/ConfirmedOrderModal/AppQrCodes/AppQrCodes'
import { useExclusiveModal } from 'src/hooks/useExclusiveModalAtom'
import { userOnboardingModalAtom } from 'src/atoms/modals/userOnboardingModal.atom'

import './DownloadAppModal.scss'

export function DownloadAppModal() {
  useExclusiveModal(userOnboardingModalAtom)
  const [{ isOpen }, setDownloadAppModal] = useAtom(downloadAppModalAtom)

  function handleClose() {
    setDownloadAppModal({ isOpen: false })
  }

  return (
    <CuiModal
      isOpen={isOpen}
      onRequestClose={handleClose}
      className="download-app-modal"
      size="small">
      <div className="download-app-modal__content">
        <h2 className="download-app-modal__title">Get the CookUnity app</h2>
        <p className="download-app-modal__subtitle">
          Simply scan the QR code below to get our app from your device's app
          store.
        </p>
        <div className="download-app-modal__qr">
          <AppQrCodes qrSize={200} />
        </div>

        <CuiButton onClick={handleClose}>Close</CuiButton>
      </div>
    </CuiModal>
  )
}
